import request from "@/service";

/* 学分统计 */
export function creditStatisticsList(data) {
  return request({
    url: `/data/credit/statistics/page`,
    method: "POST",
    data: data
  });
}

/* 导出学分统计 */
export function exportCreditStatistics(params) {
  return request({
    url: `/data/credit/statistics/export`,
    method: "put",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: params
  });
}
// 单位学分明细
export function unitCreditList(data) {
  return request({
    url: `/resource/user/creditDetail/unitCreditPage`,
    method: "POST",
    data: data
  });
}
// 导出单位学分统计列表
export function exportUnitCreditList(data) {
  return request({
    url: `/resource/user/creditDetail/exportUnitCreditList`,
    method: "put",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data
  });
}
// 导出单位学分统计报表
export function exportUnitCreditReport(data) {
  return request({
    url: `/resource/user/creditDetail/exportUnitCreditReport`,
    method: "put",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data
  });
}



